import React, { useState } from 'react'
import { Avatar, Flex, Heading, Icon } from '@chakra-ui/react'
import { ReactComponent as IC_AVATAR } from '../../../assets/icons/ic_avatar.svg'

interface IMemberItem {
    data: any
    onClick?: any
}

const MemberItem: React.FC<IMemberItem> = (props: IMemberItem) => {
    const {
        data,
        onClick,
    } = props

    const [isImageError, setIsImageError] = useState<boolean>(false)

    return (
        <Flex
            width='100%'
            gap='24px'
            cursor='pointer'
            alignItems='center'
            onClick={onClick}
        >
            {isImageError
                ?   <Flex
                        height='48px'
                        width='48px'
                        borderRadius='48px'
                        overflow='none'
                        backgroundColor='primaryContainer'
                        justifyContent='center'
                        alignItems='center'
                    >
                        <Icon 
                            as={IC_AVATAR} 
                            width='33.82px' 
                            height='30.76px' 
                            marginTop='5px' 
                            color='onPrimaryContainer' 
                        />
                    </Flex>
                :   <Avatar 
                        src={data?.user?.photo_url} 
                        name={data?.user?.username} 
                        size='sm'
                        height='48px'
                        width='48px'
                        onError={() => setIsImageError(true)}
                    />
            }
            <Flex color='onSurface' direction='column' gap='4px'>
                <Heading size='chakra_title_medium' color='onSurface'>
                    {data?.user?.display_name}
                </Heading>
                <Heading size='chakra_body_medium' color='neutral.40'>
                    {data?.user?.username}
                </Heading>
            </Flex>
        </Flex>
    )
}

export default MemberItem